module.exports = __webpack_public_path__ + "static/media/monster-success.94babe39.gif";